import { defineStore } from 'pinia'

export enum VersionActionType {
  FETCHING = 'fetching',
  FETCHED = 'fetched',
  FETCH_FAILED = 'fetch_failed',
  CREATING = 'creating',
  CREATED = 'created',
  CREATE_FAILED = 'create_failed',
  UPDATING = 'updating',
}

interface Version {
  id: number,
  status: string,
  version_name: string,
  api_version: string,
  api_url: string,
  android_version: string,
  android_market_url: string,
  ios_version: string,
  ios_market_url: string,
  webview_version: string,
  period_start_at: string,
  period_end_at: string,
  created_at: string,
}

interface VersionState {
  versions: {
    [key: string]: {
      action_type: VersionActionType,
      action_message: string,
      version: Version
    }
  }
}

export const useVersionDetailStore = defineStore('system.version.detail', {
  state: (): VersionState => ({
    versions: {},
  }),
  getters: {},
  actions: {
    async fetchVersion(id: number) {
      this.versions[id] = {
        action_type: VersionActionType.FETCHED,
        action_message: '',
        version: {id: 1, status: 'Đang hoạt động', version_name: '1.0.1', api_version: '1.0.1', api_url: 'https://api.onenetwork.vn', android_version: '1.0.1', android_market_url: '', ios_version: '1.0.1', ios_market_url: '', webview_version: '1.0.1', period_start_at: '2025-05-01 00:00:01', period_end_at: '', created_at: '2025-05-01'},
      }
    },
    async setVersion(id: number, version: Object) {
      this.versions[id] = {
        action_type: VersionActionType.FETCHED,
        action_message: '',
        version: {...this.versions[id].version, ...version},
      }
    },
  },
})
